const OwnershipCarType = {
    PRIVATE: 1,
    COMPANY: 0,
    ALL: -1
}

export default OwnershipCarType;